import type { scenes } from '@padcanvas/shared';
import { fetchWithAdmin } from '../../api/fetchHelper';

/**
 * Client for the question-scenes API — the admin Scenes page.
 *
 * The shapes are `@padcanvas/shared`'s, not a copy: the store, the batch apply
 * script and this page must agree about a stored scene, and a second copy of it
 * is how a page comes to render a field nobody writes any more.
 *
 * See docs/FeatureDesigns/question-scenes/question-scenes-target.md §9.
 */

export interface SceneListFilters {
    trust?: scenes.Trust;
    outcome?: 'scene' | 'cannot';
    confidence?: scenes.Confidence;
    agreement?: 'disagrees';
}

/** React-query key prefix for every read here, so a review can refresh them all. */
export const SCENES_QUERY_KEY = 'question-scenes';

export const scenesApi = {
    coverage: (moduleId: string) =>
        fetchWithAdmin<scenes.SceneCoverage>(
            `/question-scenes/coverage?moduleId=${encodeURIComponent(moduleId)}`),

    list: (moduleId: string, filters: SceneListFilters = {}) => {
        const params = new URLSearchParams({ moduleId });
        for (const [k, v] of Object.entries(filters)) if (v) params.set(k, v);
        return fetchWithAdmin<scenes.SceneListResponse>(`/question-scenes?${params}`);
    },

    detail: (questionId: string) =>
        fetchWithAdmin<scenes.SceneDetailResponse>(
            `/question-scenes/by-question/${encodeURIComponent(questionId)}`),

    review: (questionId: string, body: scenes.SceneReviewRequest) =>
        fetchWithAdmin<scenes.QuestionSceneDoc>(
            `/question-scenes/by-question/${encodeURIComponent(questionId)}/review`, {
                method: 'POST',
                body: JSON.stringify(body),
            }),
};
